import React, { ReactNode } from 'react';
import { useCurrentUserRole } from 'common/hooks';
import { UserRole } from 'common/types';

export type AppContextValue = {
  currentUserRole: UserRole | undefined;
};

export const AppContext = React.createContext<AppContextValue>({
  currentUserRole: undefined,
});

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const { currentUserRole } = useCurrentUserRole();

  return (
    <AppContext.Provider
      value={{
        currentUserRole,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
